import { useContext } from 'react'
import { AdminContext } from 'context/AdminContext'
import terraLogo from 'media/logos/terra_logo.png'
import trainingPeaksAppIcon from 'media/integrations/training_peaks/TrainingPeaks_App_Icon.jpg'

import UserDirectoryInputBox from 'components/UserDirectory/UserDirectoryInputBox'
import UserDirectoryInputDropdown from 'components/UserDirectory/UserDirectoryInputDropdown'
import UserDirectoryOrganizationDropdown from 'components/UserDirectory/UserDirectoryOrganizationDropdown'
import UserDirectoryGroupsDropdown from 'components/UserDirectory/UserDirectoryGroupsDropdown'

const accountTypeOptions = [
    { value: '', label: 'All Account Types' },
    { value: 'trainee', label: 'Athlete' },
    { value: 'trainer', label: 'Coach' },
    { value: 'organization-admin', label: 'Organization Admin' },
    { value: 'organization-owner', label: 'Organization Owner' },
    { value: 'super-admin', label: 'Super Admin' }
]

const basicDropdownOptions = [
    { value: '', label: 'All' },
    { value: 1, label: 'Yes' },
    { value: 0, label: 'No' },
]

const auth0ConnectionOptions = [
    { value: '', label: 'All Auth0 Types' },
    { value: 'auth0', label: 'Email/Password' },
    { value: 'google', label: 'Google' },
    { value: 'apple', label: 'Apple' },
]

const trainingPeaksOptions = [
    { value: '', label: 'All Statuses' },
    { value: 1, label: 'TrainingPeaks On' },
    { value: 0, label: 'TrainingPeaks Off' },
]

const terraOptions = [
    { value: '', label: 'All Statuses' },
    { value: 1, label: 'Terra On' },
    { value: 0, label: 'Terra Off' },
]

export default function UserDirectoryFilters() {
    const { UserDirectorySubContext } = useContext(AdminContext)

    if (UserDirectorySubContext.selectedTabKey === 'user-info') {
        return (
            <div className='space-y-4'>
                <div className="grid grid-cols-6 gap-4">
                    <UserDirectoryInputDropdown
                        options={auth0ConnectionOptions}
                        value={UserDirectorySubContext.userDirectoryFilters.auth0ConnectionFilter ?? ''}
                        onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('auth0ConnectionFilter', value)}
                    />

                    <div className='relative'>
                        <img
                            src={trainingPeaksAppIcon}
                            alt="TrainingPeaks"
                            className="absolute top-2 left-2 h-6 w-6 flex-shrink-0 rounded-sm"
                        />

                        <div className='rounded-md border border-gray-300 bg-white focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500'>
                            <select
                                className='w-full pl-10 bg-white rounded-md border-white border-r-[14px] px-3 py-2 text-gray-900 shadow-sm'
                                value={UserDirectorySubContext.userDirectoryFilters.trainingPeaksFilter ?? ''}
                                onChange={(event) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('trainingPeaksFilter', event.target.value)}
                            >
                                {trainingPeaksOptions.map((option) => (
                                    <option key={`tp-${option.value}`} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className='relative'>
                        <img
                            src={terraLogo}
                            alt="Terra Icon"
                            className="absolute top-2 left-2 h-6 w-6 flex-shrink-0"
                        />

                        <div className='rounded-md border border-gray-300 bg-white focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500'>
                            <select
                                className='w-full pl-10 bg-white rounded-md border-white border-r-[14px] px-3 py-2 text-gray-900 shadow-sm'
                                value={UserDirectorySubContext.userDirectoryFilters.wearableFilter ?? ''}
                                onChange={(event) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('wearableFilter', event.target.value)}
                            >
                                {terraOptions.map((option) => (
                                    <option key={`terra-${option.value}`} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className='col-span-2'>
                        <UserDirectoryOrganizationDropdown />
                    </div>

                    <UserDirectoryGroupsDropdown />
                </div>

                <div className="grid grid-cols-6 gap-4">
                    <UserDirectoryInputBox
                        placeholder="User Id"
                        type="number"
                        value={UserDirectorySubContext.userDirectoryFilters.userIdFilter}
                        onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('userIdFilter', value)}
                    />

                    <UserDirectoryInputBox
                        placeholder="First Name"
                        type="text"
                        value={UserDirectorySubContext.userDirectoryFilters.firstNameFilter}
                        onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('firstNameFilter', value)}
                    />

                    <UserDirectoryInputBox
                        placeholder="Last Name"
                        type="text"
                        value={UserDirectorySubContext.userDirectoryFilters.lastNameFilter}
                        onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('lastNameFilter', value)}
                    />

                    <div className='col-span-2'>
                        <UserDirectoryInputBox
                            placeholder="Email"
                            type="text"
                            value={UserDirectorySubContext.userDirectoryFilters.emailFilter}
                            onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('emailFilter', value)}
                        />
                    </div>

                    <UserDirectoryInputDropdown
                        options={accountTypeOptions}
                        value={UserDirectorySubContext.userDirectoryFilters.accountTypeFilter}
                        onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('accountTypeFilter', value)}
                    />
                </div>

                <UserDirectoryInputDropdown
                    label="Boilerplate (v5) Enabled"
                    options={basicDropdownOptions}
                    value={UserDirectorySubContext.userDirectoryFilters.boilerplateEnabledFilter}
                    onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('boilerplateEnabledFilter', value)}
                />
            </div>
        )
    }

    if (UserDirectorySubContext.selectedTabKey === 'user-info-legacy') {
        return (
            <div className='space-y-4'>
                <div className="grid grid-cols-6 gap-4">
                    <UserDirectoryInputBox
                        placeholder="User Id"
                        type="number"
                        value={UserDirectorySubContext.userDirectoryFilters.userIdFilter}
                        onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('userIdFilter', value)}
                    />

                    <UserDirectoryInputBox
                        placeholder="First Name"
                        type="text"
                        value={UserDirectorySubContext.userDirectoryFilters.firstNameFilter}
                        onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('firstNameFilter', value)}
                    />

                    <UserDirectoryInputBox
                        placeholder="Last Name"
                        type="text"
                        value={UserDirectorySubContext.userDirectoryFilters.lastNameFilter}
                        onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('lastNameFilter', value)}
                    />

                    <div className='col-span-2'>
                        <UserDirectoryInputBox
                            placeholder="Email"
                            type="text"
                            value={UserDirectorySubContext.userDirectoryFilters.emailFilter}
                            onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('emailFilter', value)}
                        />
                    </div>

                    <UserDirectoryInputDropdown
                        options={accountTypeOptions}
                        value={UserDirectorySubContext.userDirectoryFilters.accountTypeFilter}
                        onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('accountTypeFilter', value)}
                    />
                </div>

                <UserDirectoryOrganizationDropdown />

                <div className="grid grid-cols-7 gap-4">
                    <UserDirectoryInputDropdown
                        label="Personal Info Completed"
                        options={basicDropdownOptions}
                        value={UserDirectorySubContext.userDirectoryFilters.personalInfoCompletedFilter}
                        onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('personalInfoCompletedFilter', value)}
                    />

                    <UserDirectoryInputDropdown
                        label="Wearable"
                        options={basicDropdownOptions}
                        value={UserDirectorySubContext.userDirectoryFilters.wearableFilter}
                        onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('wearableFilter', value)}
                    />

                    <UserDirectoryInputDropdown
                        label="Assessment Completed"
                        options={basicDropdownOptions}
                        value={UserDirectorySubContext.userDirectoryFilters.assessmentCompletedFilter}
                        onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('assessmentCompletedFilter', value)}
                    />

                    <UserDirectoryInputDropdown
                        label="Fitness Profile Completed"
                        options={basicDropdownOptions}
                        value={UserDirectorySubContext.userDirectoryFilters.fitnessProfileCompletedFilter}
                        onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('fitnessProfileCompletedFilter', value)}
                    />

                    <UserDirectoryInputDropdown
                        label="Event Schedule Completed"
                        options={basicDropdownOptions}
                        value={UserDirectorySubContext.userDirectoryFilters.eventScheduleCompletedFilter}
                        onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('eventScheduleCompletedFilter', value)}
                    />

                    <UserDirectoryInputDropdown
                        label="Membership Activated"
                        options={basicDropdownOptions}
                        value={UserDirectorySubContext.userDirectoryFilters.membershipActivationCompletedFilter}
                        onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('membershipActivationCompletedFilter', value)}
                    />

                    <UserDirectoryInputDropdown
                        label="First Workout Completed"
                        options={basicDropdownOptions}
                        value={UserDirectorySubContext.userDirectoryFilters.firstWorkoutCompletedFilter}
                        onChange={(value) => UserDirectorySubContext.HandleUserDirectoryFiltersChange('firstWorkoutCompletedFilter', value)}
                    />
                </div>
            </div>
        )
    }
}
